<template>
    <form-row :title="title">
        <div class="form-file-box">
            <v-row align="center" class="row--small">
                <v-col cols="12" md="11">
                    <v-file-input v-model="temp" dense hide-details outlined class="rounded-0" />
                </v-col>
                <v-col cols="12" md="1">
                    <v-btn block outlined color="primary" @click="addFile" class="rounded-0">첨부</v-btn>
                </v-col>
            </v-row>
            <v-chip-group v-model="value" multiple>
                <v-chip v-for="(file, i) in value" :key="i" :value="file" class="rounded-0">
                    <span>{{ file.name }}</span>
                    <v-icon small>mdi-close</v-icon>
                </v-chip>
            </v-chip-group>
        </div>
    </form-row>
</template>

<script>
import FormRow from "./form-row.vue";
export default {
    components: { FormRow },
    props: ["value", "title"],
    data() {
        return { temp: null };
    },
    methods: {
        addFile() {
            if (this.temp) {
                this.$emit("input", [...this.value, this.temp]);
                this.temp = null;
            } else alert("파일을 추가하세요.");
        },
    },
};
</script>

<style></style>
